export class LinkFreeProtectionBillingResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "eonAccount",
            "baseName": "eonAccount",
            "type": "EonAccount",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return LinkFreeProtectionBillingResponse.attributeTypeMap;
    }
    constructor() {
    }
}
